import {CommonActions, createNavigationContainerRef, StackActions} from '@react-navigation/native';

import {AppRoutesNavigatorParamList} from '../models/navigationTypes';
import {logger} from '../utils/logger';

export const navigationRef = createNavigationContainerRef<AppRoutesNavigatorParamList>();

// This provides a ref to navigation outside of the navigation container.
// Use sparingly, there are a lot of caveats for its use.
// https://reactnavigation.org/docs/navigating-without-navigation-prop
export function navigate(name: any, params?: any) {
  if (navigationRef.isReady()) {
    navigationRef.navigate(name, params);
  }
}

export function push(...args: any[]) {
  if (navigationRef.isReady()) {
    navigationRef.current?.dispatch(StackActions.push(...args));
  }
}

export function goBack() {
  if (navigationRef.isReady()) {
    navigationRef.dispatch(CommonActions.goBack());
  }
}

export function reset(
  state = {
    index: 0,
    routes: [{name: 'MAIN'}],
  },
) {
  if (navigationRef.isReady()) {
    navigationRef.resetRoot(state);
  } else {
    logger.warn('Navigation', 'RootNavigation ref IS NOT READY');
  }
}

export function getRootState() {
  if (navigationRef.isReady()) {
    return navigationRef.getRootState();
  }
}

export function isReady() {
  return navigationRef?.isReady();
}
